module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAMAAABgOjJdAAAAYFBMVEUAAAD///////////////////////////////////////////////////////////////88PDzOzs6enp5tbW3z8/Pn5+eRkZFISEi2trZUVFTCwsKqqqp5eXlhYWGFhYXGYASuAAAAEHRSTlMAv8/fgO9AMCAQYFCPn69wIm6P2gAAAOVJREFUOMvN09tugzAMBmA7MUkIpcWUY7t27/+Ww0gZU2Wvd9P+Cw7ii/InCtC9y/8SvZ6piPvCRoZpF+v2dNUy33gZRSy8GhXGB8+b6HkwW05828W1O3IOIbvjlflVXCBTqJ0tPOB2bZItTvs3BG+L+p3w0Mos4ZemLTQU7aYSbMLF26v1rrhKFy1A9gIDxEoV9QkTxBAhuJQ1gbANdESEsmxLlJxBnSU2hVQxq8LFRE7uVL80nbsylBJIEv3cDzklY/cdj4jHlq78kFM48LPXD+HHwncR45OtSAHY7aDns/+z//YL1ARBz4XqKtgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/huiyuanqia.png
// module id = UrGE
// module chunks = 4